/* ==========================================================
   SECTION DE RASTREO DO PEDIDO
   - Injeta uma seção "Rastrea tu pedido" antes do footer
   - Usa Parcels App (universal: detecta DHL, FedEx, Estafeta,
     Mercado Envíos, 99minutos, etc.)
   ========================================================== */
(function () {
  'use strict';

  function isCheckoutPage() {
    return /\/checkouts?\//.test(window.location.pathname);
  }

  function injectSection() {
    if (isCheckoutPage()) return; // não aparece no checkout
    if (document.getElementById('bs-tracking-section')) return;

    var footer = document.querySelector('.bs-footer') || document.querySelector('footer');
    if (!footer) return;

    var section = document.createElement('section');
    section.id = 'bs-tracking-section';
    section.className = 'bs-tracking-section';
    section.innerHTML =
      '<div class="bs-tracking-container">' +
        '<div class="bs-tracking-icon">📦</div>' +
        '<div class="bs-tracking-content">' +
          '<h3 class="bs-tracking-title">Rastrea tu Pedido</h3>' +
          '<p class="bs-tracking-subtitle">Ingresa el código de rastreo que recibiste por email y sigue tu pedido en tiempo real</p>' +
          '<form class="bs-tracking-form" id="bsTrackingForm">' +
            '<input type="text" id="bsTrackingInput" class="bs-tracking-input" placeholder="Ej: 1Z999AA10123456784" autocomplete="off" spellcheck="false">' +
            '<button type="submit" class="bs-tracking-button">Rastrear</button>' +
          '</form>' +
          '<div class="bs-tracking-carriers">' +
            '<span class="bs-tracking-carriers-label">Compatible con:</span>' +
            '<span class="bs-tracking-carrier">DHL</span>' +
            '<span class="bs-tracking-carrier">FedEx</span>' +
            '<span class="bs-tracking-carrier">Estafeta</span>' +
            '<span class="bs-tracking-carrier">Mercado Envíos</span>' +
            '<span class="bs-tracking-carrier">99minutos</span>' +
            '<span class="bs-tracking-carrier">Paquetexpress</span>' +
          '</div>' +
          '<p class="bs-tracking-help">¿Todavía no recibiste el código? <a href="mailto:apoyo@bellasirena.shop">Contáctanos</a></p>' +
        '</div>' +
      '</div>';

    // Insere ANTES do footer
    footer.parentNode.insertBefore(section, footer);

    var form = document.getElementById('bsTrackingForm');
    var input = document.getElementById('bsTrackingInput');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (input.value || '').trim();
      if (!code) {
        input.focus();
        input.classList.add('bs-tracking-input--error');
        setTimeout(function () { input.classList.remove('bs-tracking-input--error'); }, 1500);
        return;
      }
      // Limpa o código (remove espaços e caracteres especiais)
      var clean = code.replace(/[^a-zA-Z0-9-]/g, '');
      // Abre o rastreio universal em nova aba
      var url = 'https://parcelsapp.com/es/tracking/' + encodeURIComponent(clean);
      window.open(url, '_blank', 'noopener,noreferrer');
    });
  }

  function run() { try { injectSection(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  [400, 1200, 2500].forEach(function (ms) { setTimeout(run, ms); });
})();
